import { BaseFlowRuleStep } from "./BaseFlowRuleStep";
import { TextMergeConfiguration } from "../../../TextMerge/TextMergeConfiguration";
import { StringDataDefinition } from "../../../Common/Data/Definitions/StringDataDefinition";

export class TextMergeStep extends BaseFlowRuleStep {
    readonly __type: string = "run_text_merge";

    executable: TextMergeConfiguration = new TextMergeConfiguration();

    constructor() {
        super();

        this.executable.executionResult = new StringDataDefinition();

        this.name = "Text Merge Step";
    }
}
